import React from "react";
import { Statistic, Space, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
const ContactPage = () => {
  const { t } = useTranslation();
  
  return (
    <Row
      style={{
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Col md={12} sm={20}>
        <Space size={30} direction="vertical">
          <h1 className="headline offer">{t('contact.title')}</h1>

          <p>
            {t('contact.description')}
          </p>
          <p>
            <h2 className="offer">taskizy.com</h2>
            ul. Fabryczna 5<br />
            73-200 Choszczno
            <br />
          </p>
          <p>
            NIP: 594-153-38-20
            <br />
            REGON: 320305252
            <br />
            <br />
            <i>{t('about.vatPayer')}</i>
          </p>
        </Space>
      </Col>
    </Row>
  );
};

export default ContactPage;
